import React from "react";

/**
 * Golden glowing "MD Impex India" brand mark.
 * size:    "sm" | "md" | "lg" | "xl"
 * sub:     optional caption line (e.g. "Customer Portal"). Rendered inline
 *          when `inline` is true, else stacked below.
 * shimmer: enable left→right gold shimmer sweep on the wordmark (v1.28.31).
 * inline:  render wordmark + sub on a single horizontal line.
 */
export default function Brand({ size = "md", sub, shimmer = false, inline = false, className = "", subClassName = "" }) {
    const sizeClass = {
        sm: "brand-gold-sm",
        md: "brand-gold-md",
        lg: "brand-gold-lg",
        xl: "brand-gold-xl",
    }[size] || "brand-gold-md";
    const wordCls = `brand-gold ${sizeClass}${shimmer ? " brand-gold-shimmer" : ""}`;
    const wrapCls = inline
        ? "inline-flex items-center gap-2 leading-none"
        : "inline-flex flex-col items-start leading-none";
    return (
        <div className={`${wrapCls} ${className}`} data-testid="brand-gold">
            <span className={wordCls}>MD Impex India</span>
            {sub && (
                <span
                    className={`brand-sub ${inline ? "ml-1" : "mt-1"} ${subClassName}`}
                >
                    {sub}
                </span>
            )}
        </div>
    );
}
